import MovimentacaoContaModel from "../models/movimentacaoContaModel";

import { IService } from "./base/iService";

export default class MovimentacaoContaService extends IService<MovimentacaoContaModel> {
    constructor() {
        super("MovimentacaoConta");
    }
}